/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Otp_LabelInputs */

const he_auth_otp_label = /** @type {(inputs: Auth_Otp_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קוד חד-פעמי`)
};

const en_auth_otp_label = /** @type {(inputs: Auth_Otp_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-time code`)
};

/**
* | output |
* | --- |
* | "One-time code" |
*
* @param {Auth_Otp_LabelInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_otp_label = /** @type {((inputs?: Auth_Otp_LabelInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Otp_LabelInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_otp_label(inputs)
	return en_auth_otp_label(inputs)
});